
import { fileInfo, downloadFile, identifyFiles, downloadZipFile } from '@/api/largeFile.js'
import extendFunctions from '@/views/Report/ReportEditor/js/extend.js'
import formatConverter from '@/views/Report/ReportEditor/js/formatConverter.js'
import defaultImage from '@/assets/images/defaultImage.svg'
import defaultAttachImage from '@/assets/images/defaultAttachment.svg'
import cannotPreview from '@/assets/images/cannotPreview.svg'
import loadingImg from '@/assets/images/loading.svg'

export default {
  owner: undefined,
  uploadFileMessage: '',
  downloadFileMessage: '',
  handleRange: null,
  localImageStorage: {
    '-1': formatConverter.base64ToBlob(defaultImage),
    '-2': formatConverter.base64ToBlob(defaultAttachImage),
    '-3': formatConverter.base64ToBlob(cannotPreview),
    '-4': formatConverter.base64ToBlob(loadingImg)
  },
  localImageRatio: {
    '-1': 1,
    '-2': 1,
    '-3': 1,
    '-4': 1
  },

  showFileSelector(range) {
    this.handleRange = range
    this.owner.$refs.fileInput.dispatchEvent(new MouseEvent('click'))
  },

  onSelectedFile: function() {
    if (this.handleRange.type === 'supply') {
      this.preUploadFile(this.owner.$refs.fileInput.files, null, this.handleRange.data)
    } else {
      var cellInNameRanges = this.owner.getSelectionNameRange(this.handleRange)
      if (cellInNameRanges.length > 0) {
        this.preUploadFile(this.owner.$refs.fileInput.files, this.handleRange)
      }
    }
    // 清空已选文件
    this.owner.$refs.fileInput.value = ''
  },

  async preUploadFile(fileList, itemInfo, data) {
    var uploadType = data ? 2 : 1
    var files = []
    var i, handleType, group
    for (i = 0; i < fileList.length; i++) {
      files.push(fileList[i])
    }
    if (!files.length) {
      return
    }
    if (uploadType === 1) {
      handleType = itemInfo.imageGroup() ? 1 : 2
      group = handleType === 1 ? extendFunctions.deepCopy(itemInfo.imageGroup()) : extendFunctions.deepCopy(itemInfo.attachGroup())
      if (!group) {
        group = { data: [] }
        if (!group.data) {
          group.data = []
        }
      }
    } else {
      group = { data }
      handleType = 2
    }
    var response = await identifyFiles(files.length)
    for (i = files.length - 1; i >= 0; i--) {
      var objId = response.data.shift()
      group.data.unshift({
        id: objId,
        name: files[i].name,
        newFile: true
      })
      this.owner.uploadFileList.push({ id: objId, obj: files[i], status: 'ready' })
      if (uploadType === 1 && handleType === 1) {
        this.localImageStorage[objId] = files[i]
      }
    }
    // 没有首图时设置首图
    group.url = URL.createObjectURL(files[0])
    if (uploadType === 1) {
      if (handleType === 1) {
        itemInfo.imageGroup(group)
      } else if (handleType === 2) {
        itemInfo.attachGroup(group)
      }
    }
    if(handleType===1){
      this.setImageGroupValue(itemInfo)
    }else{
      this.setAttachGroupValue(itemInfo)
    }
    // 模式调整
    if (this.owner.templateAttribute.uploadMode) {
      if (!this.owner.uploadingFile) {
        this.owner.liveUploadFiles()
      }
    }
  },

  downloadFiles(fileList) {
    this.downloadFileMessage = this.owner.$t('attach.prepare')
    this.owner.$notify({
      title: this.owner.$t('attach.download'),
      message: this.downloadFileMessage,
      showClose: false,
      duration: 0
    })
    if (fileList && fileList.length) {
      downloadZipFile(fileList).then(response => {
        if (response.status >= 200 && response.status < 300) {
          const fileName = response.headers['content-disposition'].split(';')[1].split('=')[1]
          var fileBlob = new Blob([response.data], { type: 'application/zip' })
          this.owner.$refs.downloadObj.href = extendFunctions.getFileURL(fileBlob)
          this.owner.$refs.downloadObj.download = fileName
          this.owner.$refs.downloadObj.dispatchEvent(new MouseEvent('click'))
          this.owner.$refs.downloadObj.href = ''
          fileBlob = null
          this.owner.$notify.closeAll()
        } else {
          extendFunctions.errorMessage(this.owner.$t('attach.donwloadFail') + response.data)
          this.owner.$notify.closeAll()
          console.error(response)
        }
      }).catch(exception => {
        extendFunctions.errorMessage(this.owner.$t('attach.donwloadFail'), exception)
        this.owner.$notify.closeAll()
      })
    } else {
      this.owner.$notify.closeAll()
    }
  },

  // 下载附件
  async downloadAttach(previewAttachId) {
    this.downloadFileMessage = this.owner.$t('attach.prepare')
    this.owner.$notify({
      title: this.owner.$t('attach.download'),
      message: this.downloadFileMessage,
      showClose: false,
      duration: 0
    })
    if (previewAttachId > 0) {
      try{
        var fileInfoResponse=await fileInfo(previewAttachId)
      }
      catch(exception){
        extendFunctions.errorMessage(this.owner.$t('attach.infoFail'), exception)
        this.owner.$notify.closeAll()
        return
      }
      if (fileInfoResponse.status >= 200 && fileInfoResponse.status < 300) {
        var previewAttachInfo = fileInfoResponse.data
        var config = {
          onDownloadProgress: progressEvent => {
            var progressPersent = ((progressEvent.loaded * 0.75) / previewAttachInfo.size * 100 | 0)
            this.downloadFileMessage = progressPersent < 100 ? `${this.owner.$t('attach.downloading')}(${progressPersent}%)...` : this.owner.$t('attach.processing')
          }
        }
        try{
          var downloadResponse=await  downloadFile(previewAttachId, config)
        }catch(exception){
          extendFunctions.errorMessage(this.owner.$t('attach.donwloadFail'), exception)
          this.owner.$notify.closeAll()
          return
        }
        if (downloadResponse.status >= 200 && downloadResponse.status < 300) {
          var arr = downloadResponse.data.split(',')
          var mime = arr[0].match(/:(.*?);/)[1]
          var bstr = atob(arr[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          var fileBlob = new Blob([u8arr], { type: mime })
          this.owner.$refs.downloadObj.href = extendFunctions.getFileURL(fileBlob)
          this.owner.$refs.downloadObj.download = previewAttachInfo.name
          this.owner.$refs.downloadObj.dispatchEvent(new MouseEvent('click'))
          this.owner.$refs.downloadObj.href = ''
          fileBlob = null
          this.owner.$notify.closeAll()
        } else {
          extendFunctions.errorMessage(this.owner.$t('attach.donwloadFail') + downloadResponse.data)
          this.owner.$notify.closeAll()
          console.error(downloadResponse)
        }
      } else {
        extendFunctions.errorMessage(this.owner.$t('attach.infoFail') + fileInfoResponse.data)
        this.owner.$notify.closeAll()
        console.error(fileInfoResponse)
      }
    } else {
      this.owner.$notify.closeAll()
    }
  },

  initTemplateImage(templateJsonFile) {
    if (templateJsonFile.sheets) {
      templateJsonFile.sheets.forEach(sheetInfo => {
        if (sheetInfo.images) {
          sheetInfo.images.forEach((imageInfo) => {
            if (!this.localImageStorage[imageInfo.id]) {
              this.downloadFile(imageInfo.id, 1).then(() => {
                this.owner.spreadSheet.sheetByName(sheetInfo.name).range(imageInfo.ref).image({
                  id: imageInfo.id,
                  url: extendFunctions.getFileURL(this.localImageStorage[imageInfo.id]),
                  type: 0,
                  ratio: this.localImageRatio[imageInfo.id]
                })
              })
            } else {
              this.owner.spreadSheet.sheetByName(sheetInfo.name).range(imageInfo.ref).image({
                id: imageInfo.id,
                url: extendFunctions.getFileURL(this.localImageStorage[imageInfo.id]),
                type: 0,
                ratio: this.localImageRatio[imageInfo.id]
              })
            }
          })
        }
      })
    }
  },

  setFieldImageGroup(sheet, fieldRange, imageInfo, sign) {
    imageInfo = imageInfo || { data: [] }
    var showImageId = -1
    if (imageInfo.data && imageInfo.data.length > 0) {
      showImageId = imageInfo.data[0].id
    }
    if ((this.owner.targetStatus === 11 || this.owner.targetStatus === 50 || this.owner.targetStatus === 20) && showImageId === -1) {
      return
    }
    if (sign) {
      sheet.range(fieldRange).sign(true)
    }
    if (this.localImageStorage[showImageId] && this.localImageRatio[showImageId]) {
      sheet.range(fieldRange).imageGroup({
        data: imageInfo.data || [],
        url: extendFunctions.getFileURL(this.localImageStorage[showImageId]),
        blankUrl: extendFunctions.getFileURL(this.localImageStorage['-1']),
        ratio: this.localImageRatio[showImageId]
      })
    } else {
      sheet.range(fieldRange).imageGroup({
        data: imageInfo.data || [],
        url: extendFunctions.getFileURL(this.localImageStorage['-4']),
        blankUrl: extendFunctions.getFileURL(this.localImageStorage['-1']),
        ratio: this.localImageRatio['-4']
      })
      this.downloadFile(showImageId, 1).then(() => {
        console.log(fieldRange, showImageId)
        if (sheet.range(fieldRange).imageGroup().data[0].id === showImageId) {
          sheet.range(fieldRange).imageGroup({
            data: imageInfo.data || [],
            url: extendFunctions.getFileURL(this.localImageStorage[showImageId]),
            blankUrl: extendFunctions.getFileURL(this.localImageStorage['-1']),
            ratio: this.localImageRatio[showImageId]
          })
        }
      })
    }
    this.setImageGroupValue(sheet.range(fieldRange))
  },

  setFieldAttachGroup(sheet, fieldRange, attachInfo) {
    attachInfo = attachInfo || { data: [] }
    var showAttachId = -2
    if (attachInfo.data && attachInfo.data.length > 0) {
      showAttachId = attachInfo.data[0].id
    }
    if ((this.owner.targetStatus === 11 || this.owner.targetStatus === 50 || this.owner.targetStatus === 20) && showAttachId === -2) {
      return
    }
    sheet.range(fieldRange).attachGroup({
      data: attachInfo.data || [],
      blankUrl: extendFunctions.getFileURL(this.localImageStorage['-2'])
    })
    this.setAttachGroupValue(sheet.range(fieldRange))
  },

  setFieldImage(sheet, fieldRange, imageId) {
    imageId = imageId || -1
    if ((this.owner.targetStatus === 11 || this.owner.targetStatus === 50 || this.owner.targetStatus === 20) && imageId === -1) {
      return
    }
    if (!this.localImageStorage[imageId] || !this.localImageRatio[imageId]) {
      this.downloadFile(imageId, 1).then(() => {
        sheet.range(fieldRange).image({
          id: imageId,
          url: extendFunctions.getFileURL(this.localImageStorage[imageId]),
          ratio: this.localImageRatio[imageId]
        })
      })
    } else {
      sheet.range(fieldRange).image({
        id: imageId,
        url: extendFunctions.getFileURL(this.localImageStorage[imageId]),
        ratio: this.localImageRatio[imageId]
      })
    }
  },

  getImageRatio(url) {
    return new Promise(resolve => {
      const img = new Image()
      img.onload = () => {
        resolve(img.naturalWidth / img.naturalHeight)
      }
      img.src = url
    })
  },

  async downloadFile(fileId, type) {
    try {
      var downloadResult = await downloadFile(fileId, null)
      if (downloadResult.status >= 200 && downloadResult.status < 300) {
        var fileObj = formatConverter.base64ToBlob(downloadResult.data)
        if (type === 1 && fileObj.type.indexOf('image') < 0) {
          this.localImageStorage[fileId] = this.localImageStorage[-3]
        } else {
          this.localImageStorage[fileId] = fileObj || this.localImageStorage[-1]
        }
        if (fileObj.type.indexOf('image') >= 0) {
          this.localImageRatio[fileId] = await this.getImageRatio(extendFunctions.getFileURL(this.localImageStorage[fileId]))
        }
      } else {
        extendFunctions.errorMessage(type === 1 ? this.owner.$t('attach.imgFail') : this.owner.$t('attach.attachFail') + downloadResult.data)
        console.error(downloadResult)
        this.localImageStorage[fileId] = this.localImageStorage['-1']
      }
    } catch (exception) {
      extendFunctions.errorMessage(type === 1 ? this.owner.$t('attach.imgFail') : this.owner.$t('attach.attachFail'), exception)
      this.localImageStorage[fileId] = this.localImageStorage['-1']
    }
  },

  async getAttachInfo(previewAttachId) {
    if (previewAttachId > 0) {
      await fileInfo(previewAttachId).then(response => {
        if (response.status >= 200 && response.status < 300) {
          var previewAttachInfo = response.data
          console.log(previewAttachInfo)
          return previewAttachInfo
        }
      })
    }
  },

  setImageGroupValue(fieldRange) {
    var imageGroup=fieldRange.imageGroup()
    if(imageGroup&&imageGroup.data&&imageGroup.data.length&&imageGroup.data[0].name){
      fieldRange.value(imageGroup.data[0].name)
    }else{
      fieldRange.value(null)
    }
  },

  setAttachGroupValue(fieldRange) {
    var attachGroup=fieldRange.attachGroup()
    if(attachGroup&&attachGroup.data&&attachGroup.data.length&&attachGroup.data[0].name){
      fieldRange.value(attachGroup.data[0].name)
    }else{
      fieldRange.value(null)
    }
  }
}
